import {
    Typography,
    CardContent,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    Divider,
    Card
} from "@mui/material";
import { IDetalheHistoricoMercadoria } from "../../../../../../types/api/estoque/detalhe-historico-mercadoria";
import { formatarValorMonetario } from "../../../../../../helpers/masks";

export default function CardProdutos({
    data
}: CardProdutosProps) {

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Grid container>
                    <Grid size={{xs: 12, md: 4}}>

                        <Typography variant="h6" component="h2" gutterBottom>
                            Produtos da NF
                        </Typography>

                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><b>Produto</b></TableCell>
                                        <TableCell align="right"><b>Quantidade</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.itens.map((produto, index: number) => (
                                        <TableRow key={produto.nf_item_id} sx={{ '& td': { minHeight: '60px', height: '60px' }, '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell>
                                                <Typography variant="caption">
                                                    {produto.nf_produto}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="caption">
                                                    {produto.nf_quantidade} {produto.nf_unidade_medida ?? ""}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid> <Divider orientation="vertical" /></Grid>
                    <Grid size={{xs: 12, md: 7.9}}>

                        <Typography ml={2} variant="h6" component="h2" gutterBottom>
                            Produtos da OC
                        </Typography>

                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><b>Código da OC</b></TableCell>
                                        <TableCell><b>Produto comprado</b></TableCell>
                                        <TableCell align="right"><b>Quantidade</b></TableCell>
                                        <TableCell align="right"><b>Valor</b></TableCell>
                                        <TableCell><b>Status</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.itens.map((produto) => (
                                        <TableRow key={produto.nf_item_id} sx={{ '& td': { minHeight: '60px', height: '60px' }, '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell>
                                                <Typography variant="caption">
                                                    {produto.numero_ordem_compra ?? '-'}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="caption">
                                                    {produto.oc_nome_produto ?? '-'}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="caption">
                                                    {produto.oc_quantidade ?? '-'} {produto.oc_unidade_medida ?? ""}
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="caption">
                                                    {produto.oc_valor ? formatarValorMonetario(produto.oc_valor) : '-'}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    label={produto.status}
                                                    size="small"
                                                    color={produto.status === "Encontrado" ? "success" : "error"}
                                                    variant="filled"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export interface CardProdutosProps {
    data: IDetalheHistoricoMercadoria;
}